/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTranslations } from "next-intl";
import type {
  I18nKeysByNamespace,
  I18nNamespace,
} from "./generated/keys.generated";

type TranslationValues = Record<string, string | number>;

export function useTypedTranslations<N extends I18nNamespace>(namespace: N) {
  const t = useTranslations(namespace);

  function translate<K extends I18nKeysByNamespace[N]>(key: K): string;
  function translate<K extends I18nKeysByNamespace[N]>(
    key: K,
    values: TranslationValues
  ): string;

  function translate<K extends I18nKeysByNamespace[N]>(
    key: K,
    values?: TranslationValues
  ): string {
    if (values) {
      return (t as any)(key, values);
    }
    return (t as any)(key);
  }

  return translate;
}
